/**
 * Nutrafol Purchase Quantity Limiter
 * Simple script to limit Nutrafol products to 3 units per customer
 */

(function() {
  const VENDOR_NAME = 'Nutrafol';
  const MAX_QUANTITY = 3;
  const ENABLE_LOGGING = true;

  function log(message) {
    if (ENABLE_LOGGING) {
      console.log('[Nutrafol Limiter]', message);
    }
  }

  // Initialize when DOM is ready
  document.addEventListener('DOMContentLoaded', function() {
    log('Initializing Nutrafol quantity limiter');
    initQuantityLimiter();
  });

  // Setup the limiter
  function initQuantityLimiter() {
    // Listen for cart updates
    document.addEventListener('cart:updated', checkCartForNutrafolLimits);
    document.addEventListener('cart.requestComplete', checkCartForNutrafolLimits);
    
    // Also check when cart drawer opens
    document.addEventListener('drawerOpen.CartDrawer', checkCartForNutrafolLimits);

    // Hook into quantity selectors for Nutrafol products
    setupQuantityControls();
    
    // Check cart on page load
    checkCartForNutrafolLimits();
  }

  // Handle quantity controls
  function setupQuantityControls() {
    // Watch for quantity changes on product pages
    document.addEventListener('click', function(e) {
      // Check for plus button clicks on product pages
      if (e.target.matches('.js-qty__adjust--plus') || e.target.closest('.js-qty__adjust--plus')) {
        const form = e.target.closest('form[action*="/cart/add"]');
        if (!form) return;
        
        const vendorElement = document.querySelector('.product__vendor');
        if (!vendorElement || !vendorElement.textContent.includes(VENDOR_NAME)) return;
        
        const quantityInput = form.querySelector('input[name="quantity"]');
        if (!quantityInput) return;
        
        setTimeout(function() {
          if (parseInt(quantityInput.value) > MAX_QUANTITY) {
            quantityInput.value = MAX_QUANTITY;
            alert('You can only purchase a maximum of ' + MAX_QUANTITY + ' units of this Nutrafol product.');
          }
        }, 10);
      }
    });
    
    // Watch for direct input changes
    document.addEventListener('change', function(e) {
      if (e.target.matches('input[name="quantity"]')) {
        const form = e.target.closest('form[action*="/cart/add"]');
        if (!form) return;
        
        const vendorElement = document.querySelector('.product__vendor');
        if (!vendorElement || !vendorElement.textContent.includes(VENDOR_NAME)) return;
        
        if (parseInt(e.target.value) > MAX_QUANTITY) {
          e.target.value = MAX_QUANTITY;
          alert('You can only purchase a maximum of ' + MAX_QUANTITY + ' units of this Nutrafol product.');
        }
      }
    });
  }

  // Check cart for Nutrafol items exceeding limit
  function checkCartForNutrafolLimits() {
    log('Checking cart for Nutrafol products');
    
    theme.cart.getCart().then(function(cart) {
      let cartUpdated = false;
      const updates = {};
      
      // Check each item for Nutrafol vendor and quantity > 3
      cart.items.forEach(function(item) {
        if (item.vendor === VENDOR_NAME && item.quantity > MAX_QUANTITY) {
          log(`Found Nutrafol item exceeding limit: ${item.title}, quantity: ${item.quantity}`);
          updates[item.id] = MAX_QUANTITY;
          cartUpdated = true;
        }
      });
      
      // Update cart if needed
      if (cartUpdated) {
        log('Updating cart to enforce Nutrafol quantity limits');
        showLimitMessage();
        
        fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ updates: updates })
        })
        .then(response => response.json())
        .then(updatedCart => {
          log('Cart updated successfully');
          
          // Dispatch event to refresh cart
          document.dispatchEvent(new CustomEvent('cart:build'));
        })
        .catch(error => {
          console.error('[Nutrafol Limiter] Error updating cart:', error);
        });
      }
    });
  }

  // Show message when limits are enforced
  function showLimitMessage() {
    const cartDrawer = document.getElementById('CartDrawer');
    if (!cartDrawer) return;
    
    // Remove existing message if present
    const existingMessage = cartDrawer.querySelector('.nutrafol-limit-message');
    if (existingMessage) {
      existingMessage.remove();
    }
    
    // Create message element
    const messageElement = document.createElement('div');
    messageElement.className = 'nutrafol-limit-message';
    messageElement.style.color = '#e74c3c';
    messageElement.style.padding = '10px';
    messageElement.style.marginBottom = '10px';
    messageElement.style.backgroundColor = '#f9f9f9';
    messageElement.style.borderRadius = '4px';
    messageElement.textContent = 'Some Nutrafol products have been adjusted to the maximum quantity of 3.';
    
    // Add to cart drawer
    const drawerInner = cartDrawer.querySelector('.drawer__inner');
    if (drawerInner) {
      drawerInner.insertBefore(messageElement, drawerInner.firstChild);
      
      // Remove after 5 seconds
      setTimeout(() => {
        messageElement.remove();
      }, 5000);
    }
  }
})();